import { useMemo } from "react";
import { SectionPage } from "@/components/section-page";
import { ProductImage } from "@/components/product-image/index";
import { DataTable } from "@/composites/data-table/index";
import { useTableCanceledStyles } from "./table-canceled.styles";
import { LocalizationText } from "@/app/index";
import { Link } from "@/components/link";
import { Text, Flex } from "@/base/components/index";
import { usePageContextHardware } from "../../context/hardware-context";

export const TableCanceled = () => {
  const { styles } = useTableCanceledStyles();
  const { controllerDataTableCanceled, currentLang } = usePageContextHardware();

  const columns: any = useMemo(
    () => [
      {
        dataIndex: "ProductName",
        title: (
          <LocalizationText value="hardware.table.canceled.column.hardware" />
        ),
        minWidth: 200,
        render: (value: any, record: any) => (
          <Flex align="center" gap={12}>
            <ProductImage
              src={record.Product?.ImageThumbName}
              width={40}
              height={40}
            />
            <Text>{value}</Text>
          </Flex>
        ),
      },
      {
        dataIndex: "BusinessUnitName",
        minWidth: 160,
        title: (
          <LocalizationText value="hardware.table.canceled.column.business.unit" />
        ),
        render: (text: string, record: any) =>
          record.BusinessUnitId && text ? (
            <Link
              to={`/${currentLang}/business-units/${record.BusinessUnitId}`}
              type="primary"
              strong
            >
              {text}
            </Link>
          ) : (
            text
          ),
      },
      {
        dataIndex: "ProductStatusName",
        minWidth: 160,
        title: (
          <LocalizationText value="hardware.table.canceled.column.status" />
        ),
      },
    ],
    [],
  );

  return (
    <SectionPage
      classNames={{
        section: styles.section,
        body: styles.body,
      }}
    >
      <DataTable
        controller={controllerDataTableCanceled}
        columns={columns}
        searched={false}
      />
    </SectionPage>
  );
};
